import swup, { fragmentPlugin } from "../entrypoints/swup";

function fetchProductMap() {
  const script = document.querySelector("[data-product-map]");
  if (!script) return [];
  const data = JSON.parse(script.innerHTML);
  return data;
}

export default (id: string) => ({
  productMap: fetchProductMap(),
  loading: false,
  quantity: 1,
  contentReplace: () => {},
  init() {
    this.createFragmentRules();

    this.contentReplace = () => {
      this.productMap = fetchProductMap();
    };

    swup.hooks.on("content:replace", this.contentReplace);
  },
  createFragmentRules() {
    const map = [...this.productMap].flatMap(
      (map) => `/products/${map.handle}`,
    );

    const reverseMap = [...map].reverse();

    if (!id) return;

    fragmentPlugin.prependRule({
      from: map,
      to: reverseMap,
      containers: [
        "#product-title",
        "#product-media",
        "#product-form",
        "#product-modal-form",
        "#product-price-container",
        "#sticky-product",
      ],
      name: id,
    });
  },
  destroy() {
    fragmentPlugin.setRules(
      fragmentPlugin.getRules().filter((rule) => !rule.name?.includes(id)),
    );
    swup.hooks.off("content:replace", this.contentReplace);
  },
  async addToCart(e: Event) {
    e.preventDefault();

    const form = e.target as HTMLFormElement;
    const formData = new FormData(form);

    const variant = formData.get("id");
    const productMapTitle = formData.get("properties[_title]");
    const sellingPlan = formData.get("selling_plan");

    const payload = [
      {
        id: Number(variant),
        quantity: Number(this.quantity) || 1,
        ...(productMapTitle ? { properties: { _title: productMapTitle } } : {}),
        ...(sellingPlan ? { selling_plan: sellingPlan } : {}),
      },
    ];

    await this.$store.cart.addLines(payload);
  },
});
